import { create } from "zustand";

const useLayoutStore = create((set) => ({
  sidebarMenuOpen: false,
  setSidebarMenuOpen: (sidebarMenuOpen) => set(() => ({ sidebarMenuOpen })),
}));

export default useLayoutStore;
